export interface Event {
  properties: { name: string; value: any; unitOfMeasure?: string }[];
}

export const GET_TABLE_QUERY = `
query GetTable($id: String!, $filter: FilterInput, $limit: Int!, $columnsToInclude: [String!], $propertiesToInclude: [PropertiesForItemUUIDColumnInput!], $sorts: [SortInput!], $cursor: CursorInput, $useDistinct: Boolean, $virtualColumns: VirtualColumnsInput, $groupBy: GroupByInput, $conditionMonitorId: String) {
  table(id: $id, filter: $filter, limit: $limit, columnsToInclude: $columnsToInclude, propertiesToInclude: $propertiesToInclude, sorts: $sorts, cursor: $cursor, useDistinct: $useDistinct, virtualColumns: $virtualColumns, groupBy: $groupBy, conditionMonitorId: $conditionMonitorId) {
    rows
    headers {
      name
      type
    }
    hasMore,
    cursorKey
  }
}
`;
